export default function company (Restangular) {
  'ngInject'
  return Restangular.all('company')
}
